<template>
  <div class="min-h-screen flex flex-col">
    <!-- Header -->
    <div class="px-4 pt-6 pb-4">
      <div class="flex items-center justify-between">
        <button
          class="inline-flex items-center justify-center bg-primary text-white rounded-[0.625rem] w-10 h-10"
          @click="goBack"
          aria-label="Назад"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none"><path d="M8 15L1 8L8 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <LogoIcon />

        <button
          class="relative inline-flex items-center justify-center bg-accent text-white rounded-[0.625rem] w-10 h-10"
          @click="$emit('open-cart')"
          aria-label="Корзина"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
              <path d="M20.0351 7.5337C19.9361 6.61887 19.4969 5.77464 18.8048 5.1683C18.1126 4.56197 17.2179 4.23779 16.298 4.26H15.2367C15.0546 3.22066 14.5119 2.2788 13.7039 1.60009C12.896 0.921391 11.8746 0.549316 10.8194 0.549316C9.76427 0.549316 8.74289 0.921391 7.93495 1.60009C7.12702 2.2788 6.58428 3.22066 6.4022 4.26H5.32592C4.40601 4.23779 3.51133 4.56197 2.81917 5.1683C2.12701 5.77464 1.68789 6.61887 1.58883 7.5337L0.654557 17.5192C0.607723 18.009 0.66473 18.5031 0.821855 18.9693C0.978979 19.4355 1.23269 19.8634 1.56641 20.2249C1.92446 20.6126 2.35913 20.9218 2.84288 21.1327C3.32664 21.3437 3.84893 21.452 4.3767 21.4506H17.2622C17.79 21.452 18.3123 21.3437 18.796 21.1327C19.2798 20.9218 19.7144 20.6126 20.0725 20.2249C20.4062 19.8634 20.6599 19.4355 20.817 18.9693C20.9742 18.5031 21.0312 18.009 20.9843 17.5192L20.0351 7.5337ZM10.8194 2.01775C11.4806 2.0199 12.1224 2.24113 12.6444 2.64684C13.1664 3.05256 13.5392 3.61986 13.7045 4.26H7.93441C8.09969 3.61986 8.4725 3.05256 8.99452 2.64684C9.51654 2.24113 10.1583 2.0199 10.8194 2.01775ZM18.9663 19.2084C18.7502 19.4451 18.4869 19.6338 18.1934 19.7626C17.8999 19.8913 17.5827 19.9571 17.2622 19.9558H4.3767C4.05621 19.9571 3.73899 19.8913 3.44548 19.7626C3.15197 19.6338 2.88868 19.4451 2.67259 19.2084C2.47967 19.0012 2.33268 18.7556 2.24124 18.4877C2.14979 18.2198 2.11594 17.9356 2.14192 17.6537L3.09861 7.67571C3.16033 7.13412 3.42383 6.63568 3.83661 6.27969C4.24939 5.9237 4.78115 5.7363 5.32592 5.75484H6.33494V7.24968C6.33494 7.44791 6.41368 7.63801 6.55385 7.77818C6.69402 7.91835 6.88413 7.9971 7.08235 7.9971C7.28058 7.9971 7.47069 7.91835 7.61086 7.77818C7.75103 7.63801 7.82977 7.44791 7.82977 7.24968V5.75484H13.8091V7.24968C13.8091 7.44791 13.8879 7.63801 14.028 7.77818C14.1682 7.91835 14.3583 7.9971 14.5565 7.9971C14.7548 7.9971 14.9449 7.91835 15.085 7.77818C15.2252 7.63801 15.304 7.44791 15.304 7.24968V5.75484H16.313C16.8603 5.73245 17.3958 5.9181 17.8117 6.27446C18.2277 6.63082 18.4934 7.13146 18.5552 7.67571L19.5119 17.6612C19.5349 17.943 19.4981 18.2264 19.4041 18.493C19.3101 18.7596 19.1609 19.0033 18.9663 19.2084Z" fill="white"/>
            </svg>          
            <span v-if="cartCount" class="absolute -top-1 -right-1 bg-white text-accent text-[10px] font-bold leading-none rounded-full min-w-[1.1rem] h-[1.1rem] flex items-center justify-center px-[2px]">{{ cartCount }}</span>
        </button>
      </div>
    </div>

    <div class="px-2">
      <div class="relative mx-auto" style="width:100%; max-width:520px;">
        <div class="relative overflow-visible" style="height:380px;">
          <div class="absolute inset-y-0 left-0 w-1/4 z-30 cursor-pointer" @click="prev" />
          <div class="absolute inset-y-0 right-0 w-1/4 z-30 cursor-pointer" @click="next" />
          <div
            v-for="(p,i) in displayProducts"
            :key="p.id || i"
            class="absolute top-1/2 left-1/2 rounded-2xl flex items-center justify-center transition-all duration-500 bg-[#E8E8E8] cursor-pointer"
            :style="previewCardStyle(i)"
            @click="goTo(i)"
          >
            <img :src="buildImageSrc(p, i === index)" :alt="p.name" class="object-contain transition-all" style="max-height:300px; max-width:80%;" />
          </div>
        </div>
        <div class="absolute -bottom-4 left-0 right-0 flex items-center justify-center gap-2 pointer-events-none">
          <span v-for="(p,i) in displayProducts" :key="'dot'+(p.id||i)" class="w-2 h-2 rounded-full" :class="i===index ? 'bg-accent' : 'bg-primary/20'" />
        </div>
      </div>
    </div>

    <div class="mt-8 rounded-t-[1.875rem] bg-white shadow-[0_-5px_20px_0_rgba(76,95,143,0.10)] p-6 pb-8 flex-1 flex flex-col">
      <h2 class="font-roboto font-bold mb-4" style="font-size:1.5rem;">{{ current.name }}</h2>
      <div v-if="current.description" class="mb-6">
        <p class="text-[#959494] text-base font-semibold mb-1">Описание</p>
        <p class="text-base leading-snug">{{ current.description }}</p>
      </div>
      <div class="flex flex-row gap-6 mb-8" v-if="hasOptions">
        <div
          v-for="optionKey in filteredOptions"
          :key="optionKey"
        >
          <p class="text-sm mb-2 font-medium text-primary">{{ displayOptionLabel(optionKey) }}</p>
          <div v-if="isColorOption(optionKey)" class="flex gap-3 flex-wrap">
            <button
              v-for="value in optionValues[optionKey]"
              :key="value"
              @click="selectOption(optionKey, value)"
              :title="value"
              :style="swatchStyle(value)"
              class="w-7 h-7 rounded-full ring-2 transition border flex items-center justify-center text-[9px] font-medium uppercase ring-transparent border-gray-300"
            >
              <span v-if="!isColorValue(value)" class="text-[8px] leading-none text-primary">{{ shortLabel(value) }}</span>
              <svg
                v-else-if="selectedOptions[optionKey] === value"
                xmlns="http://www.w3.org/2000/svg"
                width="18" height="13" viewBox="0 0 18 13" fill="none"
                class="pointer-events-none"
              >
                <path d="M16.8261 2.61779L7.44194 12.1761C7.16041 12.4629 6.79084 12.6072 6.42128 12.6072C6.05172 12.6072 5.68215 12.4629 5.40062 12.1761L0.708647 7.39694C0.143993 6.82206 0.143993 5.89256 0.708647 5.31769C1.27304 4.74254 2.18531 4.74254 2.74997 5.31769L6.42128 9.05721L14.7848 0.538537C15.3492 -0.0366088 16.2615 -0.0366088 16.8261 0.538537C17.3905 1.11341 17.3905 2.04264 16.8261 2.61779Z" :fill="isWhiteColor(value) ? '#000000' : '#FAFAFA'"/>
              </svg>
            </button>
          </div>
          <div v-else class="flex gap-2 flex-wrap">
            <button
              v-for="value in optionValues[optionKey]"
              :key="value"
              @click="selectOption(optionKey, value)"
              class="px-3 h-8 rounded-md border text-xs font-medium transition"
              :class="selectedOptions[optionKey] === value ? 'bg-primary text-white border-primary' : 'bg-white text-primary border-gray-300'"
            >
              {{ value }}
            </button>
          </div>
        </div>
      </div>
      <div class="mt-auto">
        <button
          class="w-full bg-accent text-white font-semibold rounded-lg h-12 flex items-center justify-center disabled:opacity-50"
          @click="add"
          :disabled="!current || !current.id || isAlreadyInCart"
        >
          <span v-if="isAlreadyInCart">Товар в корзине</span>
          <span v-else>Добавить в корзину</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { API_CONFIG } from '@/config'
import api from '@/services/api'
import {
  extractOptionKeys,
  buildOptionValues,
  findMatchingVariant,
  getFallbackVariant,
  resolveImage,
  autopopulateSingletons
} from '@/services/variantService'
import LogoIcon from './LogoIcon.vue'
export default {
  name: 'ProductPreviewPage',
  components: { LogoIcon },
  props: {
    products: { type: Array, required: true },
    startIndex: { type: Number, default: 0 },
    cartCount: { type: Number, default: 0 },
    cartItems: { type: Array, default: () => [] },
    productId: { type: [String, Number], default: null }
  },
  emits: ['back','open-cart','add-to-cart','index-change'],
  data(){
    return { 
      index: this.startIndex, 
      selectedOptions: {},
      imagesBaseUrl: API_CONFIG.staticBaseUrl,
      internalProducts: [],
      loadingSingle: false,
      singleError: null
    }
  },
  computed: {
    displayProducts(){
      if (this.products && this.products.length) return this.products
      return this.internalProducts
    },
    current(){ return this.displayProducts[this.index] || {} },
    productVarieties(){ return this.current.product_varieties || this.current.variants || [] },
    availableOptions(){
      return extractOptionKeys(this.productVarieties)
    },
    filteredOptions(){
      return this.availableOptions.filter(k => {
        const vals = this.optionValues[k]
        return !(this.isColorOption(k) && vals && vals.length === 1)
      })
    },
    optionValues(){
      return buildOptionValues(this.productVarieties, this.selectedOptions)
    },
    currentVariant(){
      const matched = findMatchingVariant(this.productVarieties, this.selectedOptions)
      return matched || getFallbackVariant(this.productVarieties)
    },
    displayPrice(){
      if (this.currentVariant){
        return this.currentVariant.price_preview || this.currentVariant.price || this.current.price_preview || this.current.price
      }
      return this.current.price_preview || this.current.price
    },
  hasOptions(){ return this.filteredOptions.length > 0 },
    isAlreadyInCart(){
      if(!this.current || !this.current.id) return false
      const variantId = this.currentVariant?.id || this.currentVariant?.variant_id || null
      const optionsKey = Object.entries(this.selectedOptions).sort().map(([k,v]) => `${k}:${v}`).join('|')
      const keyParts = [this.current.id, variantId || (this.currentVariant?.code), optionsKey].filter(Boolean)
      const probeKey = keyParts.join('_')
      return this.cartItems?.some(ci => ci._key === probeKey)
    },
    logoSvg(){ return this.$root.logoSvg || '' }
  },
  watch: {
    startIndex(n){ this.index = n },
    productId: {
      immediate: true,
      handler(id){
        if(id){
          if(this.products && this.products.length){
            const idx = this.products.findIndex(p => String(p.id) === String(id))
            if(idx !== -1){
              this.index = idx
              return
            }
          }
          this.ensureProductFromRoute()
        }
      }
    },
    index(newVal){
      const cur = this.displayProducts[newVal]
      if(cur && cur.id && this.$route && String(this.$route.params.id) !== String(cur.id)){
        this.pushRouteForCurrent()
      }
    },
    current: {
      immediate: true,
      handler(){
        this.$nextTick(()=>{
          this.selectedOptions = {}
          let stabilized = false
            let guard = 0
            while(!stabilized && guard < 10){
              const next = autopopulateSingletons(this.productVarieties, this.selectedOptions)
              if (next === this.selectedOptions){
                stabilized = true
              } else {
                this.selectedOptions = { ...next }
              }
              guard++
            }
        })
      }
    }
  },
  methods: {
    isColorOption(k){
      if(!k) return false
      const norm = String(k).trim().toLowerCase()
      return norm === 'цвет' || norm === 'color'
    },
    displayOptionLabel(k){
      if(this.isColorOption(k)) return 'Цвет'
      if(!k) return ''
      const trimmed = String(k).trim()
      return trimmed
    },
    isColorValue(v){
      if(!v) return false
      const val = String(v).trim().toLowerCase()
      if(/^(#[0-9a-f]{3,8})$/.test(val)) return true
      const named = ['красный','черный','чёрный','белый','синий','зелёный','зеленый','желтый','жёлтый','фиолетовый','оранжевый','розовый','коричневый','серый','голубой','бордовый']
      if(named.includes(val)) return true
      const en = ['red','black','white','blue','green','yellow','purple','orange','pink','brown','gray','grey','navy','maroon']
      return en.includes(val)
    },
    isWhiteColor(v){
      if(!v) return false
      const val = String(v).trim().toLowerCase()
      if(val === 'white' || val === 'белый' || val === '#fff' || val === '#ffffff') return true
      return false
    },
    colorNameToHex(name){
      if(!name) return '#ccc'
      const n = name.trim().toLowerCase()
      const map = {
        'красный':'#ff1e1e', 'черный':'#000000','чёрный':'#000000','белый':'#ffffff','синий':'#0044cc','зелёный':'#0d8a26','зеленый':'#0d8a26','желтый':'#ffd400','жёлтый':'#ffd400','фиолетовый':'#7a3dd8','оранжевый':'#ff7a00','розовый':'#ff65b3','коричневый':'#6b3f1d','серый':'#888888','голубой':'#3fa9f5','бордовый':'#800020',
        'red':'#ff1e1e','black':'#000000','white':'#ffffff','blue':'#0044cc','green':'#0d8a26','yellow':'#ffd400','purple':'#7a3dd8','orange':'#ff7a00','pink':'#ff65b3','brown':'#6b3f1d','gray':'#888888','grey':'#888888','navy':'#001f5b','maroon':'#800020'
      }
      return map[n] || (/#([0-9a-f]{3,8})/.test(n) ? n : '#cccccc')
    },
    swatchStyle(value){
      if(this.isColorValue(value)){
        return { background: this.colorNameToHex(value) }
      }
      return { background: '#f0f0f0' }
    },
    shortLabel(value){
      if(!value) return ''
      return String(value).slice(0,2)
    },
    buildImageSrc(p, isCurrent = false){
      if(!p) return ''
      const varieties = p.product_varieties || p.variants || []
      let variantToUse = null
      if (isCurrent){
        variantToUse = this.currentVariant
      } else {
        // Just fallback variant for neighbor to avoid showing current's selected image incorrectly
        variantToUse = findMatchingVariant(varieties, {}) || getFallbackVariant(varieties)
      }
      const raw = resolveImage(p, variantToUse)
      if (!raw) return ''
      if (/^(https?:|data:)/i.test(raw)) return raw
      return this.imagesBaseUrl + raw
    },
    previewCardStyle(i){
      const offset = i - this.index
      const baseTranslate = offset * 60
      const scale = i === this.index ? 1 : 0.8
      const z = 100 - Math.abs(offset)
      const opacity = Math.abs(offset) > 1 ? 0 : (i===this.index ? 1 : 0.45)
      const pointer = Math.abs(offset) <= 1 ? 'auto' : 'none'
      return {
        width: '300px',
        height: '100%',
        transform: `translate(-50%, -50%) translateX(${baseTranslate}%) scale(${scale})`,
        opacity,
        zIndex: z,
        pointerEvents: pointer,
        filter: 'drop-shadow(0 10px 20px rgba(55, 78, 136, 0.26))',
      }
    },
    async fetchSingleProduct(id){
      if(!id) return
      try {
        this.loadingSingle = true
        this.singleError = null
        const resp = await api.get(`products/${id}`)
        const product = resp.data?.item || resp.data
        if (product && product.id){
          this.internalProducts = [product]
          this.index = 0
        } else {
          throw new Error('Product not found in response')
        }
      } catch (e){
        console.error('Failed to fetch product', e)
        this.singleError = 'Не удалось загрузить товар'
      } finally {
        this.loadingSingle = false
      }
    },
    ensureProductFromRoute(){
      if(!this.productId) return
      const idx = this.displayProducts.findIndex(p => String(p.id) === String(this.productId))
      if(idx !== -1){
        this.index = idx
        return
      }
      this.fetchSingleProduct(this.productId)
    },
    goTo(i){
      if (i === this.index) return
      this.index = i
      this.$emit('index-change', this.index)
      this.pushRouteForCurrent()
    },
    prev(){ if (this.index>0){ this.index--; this.$emit('index-change', this.index); this.pushRouteForCurrent() } },
    next(){ if (this.index < this.displayProducts.length - 1){ this.index++; this.$emit('index-change', this.index); this.pushRouteForCurrent() } },
    pushRouteForCurrent(){
      const cur = this.current
      if(cur && cur.id && this.$router){
        this.$router.replace({ name: 'product', params: { id: cur.id } })
      }
    },
    selectOption(optionKey, value){
      this.selectedOptions = { ...this.selectedOptions, [optionKey]: value }
      let stabilized = false
      let guard = 0
      while(!stabilized && guard < 10){
        const next = autopopulateSingletons(this.productVarieties, this.selectedOptions)
        if (next === this.selectedOptions){
          stabilized = true
        } else {
          this.selectedOptions = { ...next }
        }
        guard++
      }
    },
    add(){
      const p = this.current
      if(!p || !p.id) return
      const variant = this.currentVariant
      this.$emit('add-to-cart', {
        ...p,
        selectedOptions: { ...this.selectedOptions },
        variantId: variant?.id || variant?.variant_id || null,
        variantCode: variant?.code || null,
        price_preview: this.displayPrice,
        image: (variant?.images?.[0] || p.image)
      })
    },
    handleKey(e){
      if(e.key==='ArrowLeft') this.prev()
      if(e.key==='ArrowRight') this.next()
      if(e.key==='Escape'){
        if(this.$router){ this.$router.push({ name: 'catalog' }) } else { this.$emit('back') }
      }
    },
    goBack(){
      if(this.$router){ this.$router.push({ name: 'catalog' }) } else { this.$emit('back') }
    }
  },
  mounted(){ 
    window.addEventListener('keydown', this.handleKey)
    this.ensureProductFromRoute()
  },
  beforeUnmount(){ window.removeEventListener('keydown', this.handleKey) }
}
</script>

<style scoped>
::-webkit-scrollbar { width: 6px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.12); border-radius: 3px; }
</style>